<section class="panel">
    <div class="panel-body">
        <div class="table-responsive" *ngIf="auditTemplateModules?.length>0">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Module Name</th>
                        <th class="text-center">Mandatory</th>
                        <th class="text-center">Singular</th>
                        <th class="text-center">Active</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="drop($event)">
                    <tr *ngFor="let a of auditTemplateModules;index as i" cdkDrag class="draggable">
                        <td>{{i+1}}</td>
                        <td>{{a.name}}</td>
                        <td class="text-center">
                            <span class="fas fa-check" *ngIf="a.isMandatory"></span>
                            <span class="fas fa-times" *ngIf="!a.isMandatory"></span>
                        </td>
                        <td class="text-center">
                            <span class="fas fa-check" *ngIf="a.isSingular"></span>
                            <span class="fas fa-times" *ngIf="!a.isSingular"></span>
                        </td>
                        <td class="text-center">
                            <span class="fas fa-check" *ngIf="a.isActive"></span>
                            <span class="fas fa-times" *ngIf="!a.isActive"></span>
                        </td>
                        <td class="actions text-center">
                            <a (click)="selectedModuleId=a.moduleId; confirmation.showMessage()" title="Delete Module" class="mb-1 mt-1 me-2 text-primary"><i class="fas fa-trash"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card" *ngIf="auditTemplateModules?.length==0">
            <div class="card-body card-info">
                <p>No Modules added to this Audit Template</p>
            </div>
        </div>
    </div>
</section>

<app-confirmation-message #confirmation (confirmationClicked)="deleteAuditTemplateModules()"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this module?'">
</app-confirmation-message>
